import { __assign } from "tslib";
import React from 'react';
import CloseIcon from '@wix/da-ds/pkg/Icons/24x24/Close';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import ButtonB5 from '../../../Button/ButtonB5';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { getDeviationResourceType } from '../../_helpers';
var ThumbRemove = function (_a) {
    var deviation = _a.deviation, className = _a.className, biData = _a.biData, onRemove = _a.onRemove;
    return (React.createElement("div", { className: className },
        React.createElement(ButtonB5, { icon: CloseIcon, iconProps: {
                size: IconSize.MEDIUM,
            }, withBackground: true, biData: __assign(__assign({}, biData), { evid: BiEventType.WATCH_ITEM_REMOVE_CLICK, typeid: getDeviationResourceType(deviation), itemid: deviation.deviationId }), onClick: onRemove })));
};
ThumbRemove.displayName = 'ThumbRemove';
export default ThumbRemove;
//# sourceMappingURL=ThumbRemove.js.map